export default __webpack_public_path__ + "static/media/secondArti.d8280e29.png";